export const SHIPPERS_NEED_WMS_CONFIRM = [
  '5f2c3bcefb19db512bc2663f',
  '5f4553fe465e0535da27b45c'
];
